import { create } from "../../../../../common/utils/zustand_state_manager";


type State = {
    nome?: string;
    codigo?: string;
    descricao?: string;
    status?: number;
};

type Action = {
    setNome: (nome: string | undefined) => void,
    setCodigo: (codigo: string | undefined) => void,
    setDescricao: (descricao: string | undefined) => void,
    setStatus: (status: number) => void,
    clearFilters: () => void
};

export const useTermoListaFilters = create<State & Action>((set) => ({
    nome: undefined,
    codigo: undefined,
    descricao: undefined,
    status: 2,
    setCodigo: (codigo) => set({ codigo }),
    setDescricao: (descricao) => set({ descricao }),
    setStatus: (status) => set({ status }),
    setNome: (nome) => set({ nome }),
    clearFilters: () => set({
        codigo: undefined,
        nome: undefined,
        descricao: undefined,
        status: 2,
    }),
}));

export const initialTermoFiltersValues: State = {
    nome: undefined,
    codigo: undefined,
    descricao: undefined,
    status: 2,

}